import React from "react";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";

const ToggleButtons = ({ label, value, onChange }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 3,
    }}
  >
    <Typography sx={{ color: "#666", fontWeight: 500, flex: 1, pr: 4 }}>{label}</Typography>
    <ToggleButtonGroup
      value={value === null ? "" : value ? "yes" : "no"}
      exclusive
      onChange={(event, newValue) => {
        if (newValue !== null) {
          onChange(newValue === "yes");
        }
      }}
      size='small'
    >
      <ToggleButton
        value='yes'
        sx={{
          "&.MuiToggleButton-root": {
            border: "1px solid #ddd",
            px: 3,
            "&.Mui-selected": {
              bgcolor: "primary.main",
              color: "white",
              "&:hover": {
                bgcolor: "primary.dark",
              },
            },
            "&:hover": {
              bgcolor: "#f9f9f9",
            },
          },
        }}
      >
        Yes
      </ToggleButton>
      <Box sx={{ width: 16 }} />
      <ToggleButton
        value='no'
        sx={{
          "&.MuiToggleButton-root": {
            border: "1px solid #ddd",
            px: 3,
            "&.Mui-selected": {
              bgcolor: "error.main",
              color: "white",
              "&:hover": {
                bgcolor: "error.dark",
              },
            },
            "&:hover": {
              bgcolor: "#f9f9f9",
            },
          },
        }}
      >
        No
      </ToggleButton>
    </ToggleButtonGroup>
  </Box>
);

const BodyInformationRightSide = ({ medicalData, onDataChange }) => {
  const { medicalAttentionRequired, medicalAttentionOffered, timeOfAttention, provider, complained, visualSigns } =
    medicalData;

  return (
    <Box sx={{ flex: 1 }}>
      <Box sx={{ maxWidth: 600 }}>
        <ToggleButtons
          label='Was medical attention required within 24 hours?'
          value={medicalAttentionRequired}
          onChange={(value) => onDataChange("medicalAttentionRequired", value)}
        />

        <ToggleButtons
          label='Was medical attention offered?'
          value={medicalAttentionOffered}
          onChange={(value) => onDataChange("medicalAttentionOffered", value)}
        />

        <Box sx={{ mb: 3 }}>
          <Typography sx={{ color: "#666", fontWeight: 500, mb: 1 }}>Time medical attention offered (24hr)</Typography>
          <TextField
            type='time'
            value={timeOfAttention}
            onChange={(e) => onDataChange("timeOfAttention", e.target.value)}
            variant='outlined'
            size='small'
            sx={{
              width: 170,
              "& .MuiOutlinedInput-root": {
                borderRadius: 1,
              },
            }}
          />
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography sx={{ color: "#666", fontWeight: 500, mb: 1 }}>Who provided medical attention?</Typography>
          <FormControl fullWidth sx={{ maxWidth: 300 }}>
            <Select
              value={provider}
              onChange={(e) => onDataChange("provider", e.target.value)}
              displayEmpty
              variant='outlined'
              size='small'
              sx={{
                borderRadius: 1,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ddd",
                },
              }}
            >
              <MenuItem value='Hospital'>Hospital</MenuItem>
              <MenuItem value='First Aid'>First Aider</MenuItem>
              <MenuItem value='GP'>GP</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <ToggleButtons
          label='Has the Young Person Complained of any injury or discomfort?'
          value={complained}
          onChange={(value) => onDataChange("complained", value)}
        />

        <ToggleButtons
          label='Are there any visual signs of injury?'
          value={visualSigns}
          onChange={(value) => onDataChange("visualSigns", value)}
        />
      </Box>
    </Box>
  );
};

export default BodyInformationRightSide;
